var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "de-container",
    [
      _c(
        "de-aside-container",
        [
          _c("dataset-group-selector-tree", {
            attrs: {
              "checked-table": _vm.checkedTable,
              privileges: _vm.privileges,
              mode: _vm.mode,
              "clear-empty-dir": _vm.clearEmptyDir,
              type: _vm.type,
              "custom-type": _vm.customType,
              "show-mode": _vm.showMode,
            },
            on: { getTable: _vm.getTable },
          }),
        ],
        1
      ),
      _c(
        "de-main-container",
        [_c("dataset-table-data", { attrs: { table: _vm.table } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }